export default "__VITE_ASSET__CwXiWt1G__"